import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Signal « les écrans ProFiscale ont de nouvelles données à afficher ».
 *
 * <p>Les composants de `profiscale-prestacode` mutent des champs simples dans des
 * callbacks asynchrones, sans signal ni `markForCheck`. {@code ProfiscaleComponent}
 * s'abonne à ce flux pour marquer son sous-arbre à rafraîchir, ce qui garantit l'affichage
 * du résultat quelle que soit la stratégie de détection de changement de l'hôte.
 *
 * <p><b>Toute source asynchrone alimentant la librairie doit appeler {@link notify}</b>
 * une fois les callbacks des composants exécutés (typiquement dans un `finalize`).
 */
@Injectable({ providedIn: 'root' })
export class ProfiscaleRefreshService {
  private readonly _refresh$ = new Subject<void>();
  readonly refresh$: Observable<void> = this._refresh$.asObservable();

  notify(): void {
    this._refresh$.next();
  }
}
